import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { FuncaoRequest } from '@/core/api/sicom-api/registro/medico/funcao/funcao.model';
import { FuncaoService } from '@/core/api/sicom-api/registro/medico/funcao/funcao.service';
import { environment } from 'src/environments/environment';
import { buildPageableQuery, Pageable } from '@/shared/models/pageable.model';

export interface MedicoComposicaoResponse {
    dsCargo: string;
    dtInicio: string | null;
    dtFim: string | null;
    nmSolicitante: string;
    ufSgUf: string;
    idSolicitante: number;
}

@Injectable({
    providedIn: 'root'
})
/** Fachada de funções e composição (mandatos) do médico. */
export class FuncoesFeatureService extends CustomService {
    private readonly composicaoUrl = `${environment.apis.apiSicom}/api/v1/cadastro/medico/composicao/consulta`;

    private readonly funcaoService = inject(FuncaoService);
    private readonly http = inject(HttpClient);

    /**
     * Funções do médico em entidades.
     * GET /api/v1/cadastro/medico/funcao/consulta
     * Envia PessoaRequest via query string, conforme padrão do RequestBuilder (chaves planas: id, uf).
     */
    buscar(params: Pessoa, page?: Pageable): Observable<FuncaoRequest[]> {
        return this.funcaoService.buscar(params, page).pipe(catchError(this.handleError));
    }

    /**
     * Composição do médico (grid superior - Funções em Entidades).
     * GET /api/v1/cadastro/medico/composicao/consulta
     * Envia PessoaRequest via query string (id, uf).
     */
    buscarComposicao(params: Pessoa, page?: Pageable): Observable<MedicoComposicaoResponse[]> {
        let queryParams = new HttpParams();

        queryParams = queryParams.set('id', String(params?.id ?? ''));
        queryParams = queryParams.set('uf', String(params?.uf ?? ''));

        if (page) queryParams = buildPageableQuery(queryParams, page);

        return this.http.get<MedicoComposicaoResponse[]>(this.composicaoUrl, { params: queryParams }).pipe(catchError(this.handleError));
    }
}
